import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1d": "#747474",
    "col1l": "#BFBFBF",
    "col1n": "#999999",
    "col1s": "#434343",
    "col2n": "#FFFFFF"
}
function ShiMot124({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill="#F60"
                    d="M170.9 264h-.1q0 .05.05.1 0-.05.05-.1m6-5.2q.05-.05.1-.05-.05-.05-.1-.05v.1z"
                    id="ShiMot124__Layer9_0_FILL"
                />
                <path
                    fill={colors.col1n}
                    d="M42.15 11.5q1.25-1.45 1.5-5 .15-2.5-.3-4.5-.05-.25-.1-.45-.6-1.6-2.15-1.5-2-.15-4.45.35-2.2.45-3.55 1.15-.8.45-1.3 1-1.2 1.4-1.55 2.35-.1.2-.15.6-3.75-1.7-8.2-1.7-4.5 0-8.25 1.75V5.5q-.1-.4-.2-.6-.35-.95-1.55-2.35-.5-.55-1.3-1Q9.25.85 7.05.4 4.6-.1 2.6.05 1.05-.05.5 1.55q-.1.2-.15.45-.45 2-.3 4.5.25 3.55 1.5 5 1.15 1.5 2.05 2 .3.1.95.3.05 0 .05.05-.05.05-.1.15-2.45 4.3-2.45 9.6 0 5.4 2.5 9.8h.05q1.3 2.3 3.3 4.3l.4.4q5.7 5.4 13.6 5.4 8.25 0 14-5.8 5.85-5.8 5.85-14 0-1.4-.15-2.7-.5-3.8-2.3-7-.05-.05-.05-.1l-.1-.1q.6-.2.95-.3.9-.5 2.05-2z"
                    id="ShiMot124__Symbol_111_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1d}
                    d="M15.4 14.4q5.2-3.5 3.5-10.25-2.55-4.3-4.45-4-1.9-.55-3.75 1.15Q6.65 4.25 4.95 5 3.05 5.75.2 7.3 0 8.65 0 10.1q0 4 1.4 7.45 7.8 2.35 14-3.15m9.35-14q-1.8-.1-4 3.75-2.1 6.45 3.2 10.5 7.15 5.45 14.3 2.9 1.4-3.45 1.4-7.45 0-1.45-.2-2.8-2.15-1.15-4.25-2.55t-3.3-2q-1.25-.6-2.85-1.65-1.6-1.1-4.3-.7z"
                    id="ShiMot124__Symbol_112_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    d="M42.15 11.5q1.25-1.45 1.5-5 .15-2.5-.3-4.5-.05-.25-.1-.45-.6-1.6-2.15-1.5-2-.15-4.45.35-2.2.45-3.55 1.15-.8.45-1.3 1-1.2 1.4-1.55 2.35-.1.2-.15.6-3.75-1.7-8.2-1.7-4.5 0-8.25 1.75V5.5q-.1-.4-.2-.6-.35-.95-1.55-2.35-.5-.55-1.3-1Q9.25.85 7.05.4 4.6-.1 2.6.05 1.05-.05.5 1.55q-.1.2-.15.45-.45 2-.3 4.5.25 3.55 1.5 5 1.15 1.5 2.05 2 .3.1.95.3.05 0 .05.05-.05.05-.1.15-1.8 3.15-2.25 6.8 2.9-.1 5.65-1.75 1-.6 1.95-1.4h.05q.95-.8 1.9-1.35 2.8-1.9 5.45-1.25 1.85.2 3.7 2.6.6 6-3.95 9.8-6.5 4.9-13.55 3.6.45 1.2 1.1 2.35h.05q1.3 2.3 3.3 4.3l.4.4q5.7 5.4 13.6 5.4 8.25 0 14-5.8 5.85-5.8 5.85-14 0-1.4-.15-2.7-.5-3.8-2.3-7-.05-.05-.05-.1l-.1-.1q.6-.2.95-.3.9-.5 2.05-2m-.65 9.3q.2 1.35.2 2.8 0 4-1.4 7.45-7.05 1.3-13.55-3.6-4.55-3.8-3.95-9.8 1.85-2.4 3.7-2.6 2.65-.65 5.45 1.25.95.55 1.9 1.35h.05q.95.8 1.95 1.4 2.75 1.65 5.65 1.75z"
                    id="ShiMot124__Symbol_110_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1s}
                    d="M8.4 3.95V3.9q-.35-1.1-1-1.8-.7-.85-1.45-1.15Q5.4.65 4 .3 2.5-.05 1.9 0h-.65Q.85.05.7.15.6.2.5.3.4.4.3.55q-.6 2.65 0 5.1 0 .1.05.15.25.7.85 1.45.05.05.1.15.7.8 1.9 1.3l.05.05q.6-.8 1.3-1.5.25-.3.5-.55 1.6-1.6 3.35-2.75M36.75 0h-.65q-.6-.05-2.1.3-1.4.35-1.95.65-.75.3-1.45 1.15-.65.75-.9 1.85 1.55 1 2.95 2.35l.4.4.55.55q.25.3.55.6.3.4.65.85.6-.25 1.05-.55.5-.35.85-.75.05-.1.15-.15.55-.75.8-1.45.65-2.65 0-5.3-.05-.1-.15-.2-.1-.1-.2-.15-.15-.1-.55-.15z"
                    id="ShiMot124__Symbol_113_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M18.7 5.6l-.1-.5q-.35-2.65-2.1-3.95-1.1-.9-2.4-1.1h-.3Q13.7 0 13.55 0H13.25q-.85.05-1.8.35-1.8.5-3.9 1.95-.55.4-1.05.75l-.05.05Q3.7 4.9.7 5.4.2 7.15 0 8.75 2.9 8.65 5.65 7q1-.6 1.95-1.4h.05q.95-.8 1.9-1.35Q12.35 2.35 15 3q1.85.2 3.7 2.6m14.05-2.55q-.5-.35-1.05-.75Q29.6.85 27.8.35 26.85.05 26 0H25.7q-.15 0-.25.05h-.3q-1.3.2-2.4 1.1-1.75 1.3-2.1 3.95l-.1.5q1.85-2.4 3.7-2.6 2.65-.65 5.45 1.25.95.55 1.9 1.35h.05q.95.8 1.95 1.4 2.75 1.65 5.65 1.75-.2-1.6-.7-3.35-3-.5-5.75-2.3l-.05-.05z"
                    id="ShiMot124__Symbol_114_0_Layer0_0_FILL"
                />
                <path
                    d="M198.2 297.85q-.213.013-.4.2-.686.746-1.15.95-.35.208-.8.2-.444.001-.75-.1 0 .012-.05 0-.17-.051-.65-.35v.05q-.91-.585-2.1-.65h-.05q-1.202.058-2.1.65l.05-.05q-.47.297-.7.35-.05.009-.1 0-.232.097-.7.1-.406.005-.8-.2-.44-.224-1-.95-.128-.17-.4-.2-.224-.03-.45.1-.17.178-.2.4-.03.273.1.45.79 1.023 1.45 1.3l-.05-.05q.656.345 1.35.35.64.003 1-.1.37-.047 1.1-.5.634-.397 1.45-.45.86.035 1.5.45h.05q.72.451 1 .5l-.05-.05q.444.149 1.1.15.75-.008 1.35-.35.586-.246 1.45-1.2.2-.18.2-.45-.013-.213-.2-.4-.18-.151-.45-.15m-7.15-5.9q-.65.6-.65 1.55 0 .9.65 1.55t1.55.65q.95 0 1.6-.65.6-.65.6-1.55 0-.95-.6-1.55-.65-.65-1.6-.65-.9 0-1.55.65m-2.7-9.15q-.7-.95-1.75-.95t-1.8.95q-.4.6-.6 1.3-.1.45-.1 1 0 1.35.7 2.25.75.95 1.8.95t1.75-.95q.75-.9.75-2.25 0-.55-.1-1-.2-.7-.65-1.3m12.05 0q-.7-.95-1.75-.95t-1.8.95q-.4.6-.6 1.3-.1.45-.1 1 0 1.35.7 2.25.75.95 1.8.95t1.75-.95q.75-.9.75-2.25 0-.55-.1-1-.2-.7-.65-1.3z"
                    id="ShiMot124__Layer1_0_FILL"
                />
            </defs>
            <use xlinkHref="#ShiMot124__Layer9_0_FILL" />
            <use
                xlinkHref="#ShiMot124__Symbol_111_0_Layer0_0_FILL"
                transform="translate(170.65 264.35)"
                id="ShiMot124__col1n"
            />
            <use
                xlinkHref="#ShiMot124__Symbol_112_0_Layer0_0_FILL"
                transform="translate(172.7 277.85)"
                id="ShiMot124__col1d"
            />
            <use
                xlinkHref="#ShiMot124__Symbol_110_0_Layer0_0_FILL"
                transform="translate(170.65 264.35)"
                id="ShiMot124__col1l"
            />
            <use
                xlinkHref="#ShiMot124__Symbol_113_0_Layer0_0_FILL"
                transform="translate(173.5 267.25)"
                id="ShiMot124__col1s"
            />
            <use
                xlinkHref="#ShiMot124__Symbol_114_0_Layer0_0_FILL"
                transform="translate(172.9 276.4)"
                id="ShiMot124__col2n"
            />
            <use xlinkHref="#ShiMot124__Layer1_0_FILL" />
        </g></g>
    )
}
export default ShiMot124
